import { Title } from '@angular/platform-browser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
var TitlePagesService = /** @class */ (function () {
    function TitlePagesService(titleService) {
        this.titleService = titleService;
    }
    TitlePagesService.prototype.changeTitlePage = function (name, type) {
        switch (type) {
            case 'inquire':
                this.titleService.setTitle(name + ' - Inquire your Cruise');
                break;
            case 'thanks':
                this.titleService.setTitle(name + ' - Thank you Page');
                break;
        }
    };
    TitlePagesService.ngInjectableDef = i0.defineInjectable({ factory: function TitlePagesService_Factory() { return new TitlePagesService(i0.inject(i1.Title)); }, token: TitlePagesService, providedIn: "root" });
    return TitlePagesService;
}());
export { TitlePagesService };
